module.exports = __webpack_public_path__ + "@/assets/img/menu.88b6c617.svg";